import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { observer } from "mobx-react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Box from "../../../../../Styled/Box";
import Ul, { Li } from "../../../../../Styled/List";
import Spacing from "../../../../../Styled/Spacing";
import Text from "../../../../../Styled/Text";
import parseCustomHtmlToReact from "../../../../Custom/parseCustomHtmlToReact";
import { parseCustomMarkdownToReactWithOptions } from "../../../../Custom/parseCustomMarkdownToReact";
import CloseButton from "../../../../Generic/CloseButton";
import { PrefaceBox } from "../../../../Generic/PrefaceBox";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const AttributionText = styled(Text).attrs(() => ({
  medium: true
})).withConfig({
  displayName: "DataAttributionModal__AttributionText",
  componentId: "sc-1020vfx-0"
})(["a{color:", ";text-decoration:underline;img{height:19px;vertical-align:middle;}}"], props => props.theme.textDark);
const DataAttributionBox = styled(Box).attrs({
  position: "absolute",
  styledWidth: "500px",
  styledMaxHeight: "320px",
  backgroundColor: "white",
  rounded: true,
  paddedRatio: 4,
  overflowY: "auto",
  scroll: true,
  column: true
}).withConfig({
  displayName: "DataAttributionModal__DataAttributionBox",
  componentId: "sc-1020vfx-1"
})(["z-index:99989;left:50%;top:50%;transform:translate(-50%,-50%);box-shadow:0 6px 6px 0 rgba(0,0,0,0.12),0 10px 20px 0 rgba(0,0,0,0.05);@media (max-width:", "px){width:100%;}", " img[title=\"Bing Imagery\"]{filter:invert(1);}"], props => props.theme.mobile, AttributionText);
export const DataAttributionModal = observer(_ref => {
  let {
    closeModal,
    attributions,
    searchAttributions
  } = _ref;
  const {
    t
  } = useTranslation();
  if (!attributions || attributions.length === 0) {
    return null;
  }
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_StyledPrefaceBox, {
      onClick: closeModal,
      role: "presentation",
      "aria-hidden": "true",
      pseudoBg: true
    }), /*#__PURE__*/_jsxs(DataAttributionBox, {
      children: [/*#__PURE__*/_jsx(CloseButton, {
        color: "#red",
        topRight: true,
        onClick: closeModal
      }), /*#__PURE__*/_jsx(Text, {
        extraExtraLarge: true,
        bold: true,
        textDarker: true,
        children: t("map.extraCreditLinks.mapCredits")
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 2
      }), /*#__PURE__*/_jsxs(Box, {
        column: true,
        children: [/*#__PURE__*/_jsx(Text, {
          extraLarge: true,
          medium: true,
          textDarker: true,
          children: t("map.extraCreditLinks.dataProvider")
        }), /*#__PURE__*/_jsx(Spacing, {
          bottom: 2
        }), /*#__PURE__*/_jsx(Box, {
          paddedHorizontally: 4,
          children: /*#__PURE__*/_jsx(_StyledUl, {
            children: attributions.map((attribution, index) => /*#__PURE__*/_jsx(Li, {
              children: /*#__PURE__*/_jsx(AttributionText, {
                children: parseCustomHtmlToReact(attribution)
              })
            }, index))
          })
        })]
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 4
      }), /*#__PURE__*/_jsxs(Box, {
        column: true,
        children: [/*#__PURE__*/_jsx(Text, {
          extraLarge: true,
          medium: true,
          textDarker: true,
          children: t("map.extraCreditLinks.searchProvider")
        }), /*#__PURE__*/_jsx(Spacing, {
          bottom: 2
        }), /*#__PURE__*/_jsx(Box, {
          paddedHorizontally: 4,
          children: /*#__PURE__*/_jsx(_StyledUl2, {
            column: true,
            gap: 2,
            children: searchAttributions.map((attribution, index) => /*#__PURE__*/_jsx(Li, {
              children: /*#__PURE__*/_jsx(AttributionText, {
                children: parseCustomMarkdownToReactWithOptions(attribution, {
                  inline: true
                })
              })
            }, index))
          })
        })]
      })]
    })]
  }), document.getElementById("map-data-attribution") || document.body);
});
var _StyledPrefaceBox = styled(PrefaceBox).withConfig({
  displayName: "DataAttributionModal___StyledPrefaceBox",
  componentId: "sc-1020vfx-2"
})({
  top: 0,
  left: 0,
  zIndex: 99989
});
var _StyledUl = styled("ul").withConfig({
  displayName: "DataAttributionModal___StyledUl",
  componentId: "sc-1020vfx-3"
})({
  padding: 0,
  margin: 0
});
var _StyledUl2 = styled(Ul).withConfig({
  displayName: "DataAttributionModal___StyledUl2",
  componentId: "sc-1020vfx-4"
})({
  listStyle: "disc"
});